import React, { useEffect } from 'react'
import { Modal } from 'reactstrap'
import { X } from 'react-feather'

import '@src/assets/scss/ntts-tokens.css'
import '@src/assets/scss/ntts-dialog.scss'
// .ntts-btn / .ntts-icon-btn (header × and footer buttons) live here; import
// them so dialogs are styled on pages that don't load NttsTable themselves
import '../NttsTable/NttsTable.scss'

const CustomModal = ({
  isOpen,
  onClose,
  onClosed,
  title,
  className = '',
  children,
  ...rest
}) => {
  // Lock page scroll while open. reactstrap only sets overflow: hidden on the modal, which doesn't prevent scrolling the page behind it.
  useEffect(() => {
    if (!isOpen) return
    const { style } = document.body
    const previousOverflow = style.overflow
    style.overflow = 'hidden'
    return () => {
      style.overflow = previousOverflow
    }
  }, [isOpen])

  return (
    <Modal
      isOpen={isOpen}
      toggle={onClose}
      onClosed={onClosed}
      className={`modal-dialog-centered ntts-dialog ${className}`.trim()}
      contentClassName="ntts-dialog__content"
      backdropClassName="ntts-dialog-backdrop"
      {...rest}
    >
      {title && (
        <div className="ntts-dialog__header">
          <h2>{title}</h2>
          <button
            type="button"
            className="ntts-icon-btn"
            onClick={onClose}
            aria-label="Close"
          >
            <X />
          </button>
        </div>
      )}
      {children}
    </Modal>
  )
}

export default CustomModal
